// src/components/Header.js
import React from 'react';
import './Header.css';

function Header() {
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        <h1 className="logo">It's E2e</h1>
        <nav className="nav">
          <a href="#company" onClick={(e) => scrollToSection(e, 'company')}>COMPANY</a>
          <a href="#customers" onClick={(e) => scrollToSection(e, 'customers')}>CUSTOMERS</a>
          <a href="#services" onClick={(e) => scrollToSection(e, 'services')}>SERVICES</a>
          <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>CONTACT</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;